import { message } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';

export const useDateRangePicker = ({
    initialStart,
    initialEnd,
    maxRangeDays,
}) => {
    // datepicker 시작일
    const [startDate, setStartDate] = useState(initialStart || null);
    // datepicker 종료일
    const [endDate, setEndDate] = useState(initialEnd || null);

    const [startOpen, setStartOpen] = useState(false);
    const [endOpen, setEndOpen] = useState(false);

    const handleStartChange = (value, comparedEndDttm) => {
        setStartDate(value);
        if (
            comparedEndDttm &&
            value &&
            moment(value).isAfter(moment(comparedEndDttm))
        ) {
            message.error({
                content: '시작일을 확인해주세요',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            setStartOpen(true); // 유효성 실패 시 다시 열기
            return;
        }
        // 최대 일수 제한이 있는 경우에만 체크
        if (maxRangeDays && comparedEndDttm) {
            const diffDays = moment(comparedEndDttm).diff(
                moment(value),
                'days',
            );
            console.log('diffDays', diffDays);
            console.log('comparedEndDttm', comparedEndDttm);
            console.log('value', diffDays);
            if (diffDays > maxRangeDays) {
                message.error({
                    content: `최대 ${maxRangeDays}일 까지 조회 가능합니다.`,
                    style: {
                        marginTop: '90vh',
                    },
                    duration: 1,
                });
                setStartOpen(true); // 유효성 실패 시 다시 열기
                return;
            }
        }
        setStartOpen(false); // 정상 입력시 닫기
    };

    const handleEndChange = (value, comparedStartDate) => {
        setEndDate(value);
        if (
            comparedStartDate &&
            value &&
            moment(value).isBefore(moment(comparedStartDate))
        ) {
            message.error({
                content: '마감일을 확인해주세요',
                style: {
                    marginTop: '90vh',
                },
                duration: 1,
            });
            setEndOpen(true);
            return;
        }
        if (maxRangeDays && comparedStartDate) {
            const diffDays = moment(value).diff(
                moment(comparedStartDate),
                'days',
            );
            console.log('diffDays', diffDays);
            console.log('comparedEndDttm', comparedStartDate);
            console.log('value', diffDays);
            if (diffDays > maxRangeDays) {
                message.error({
                    content: `최대 ${maxRangeDays}일 까지 조회 가능합니다.`,
                    style: {
                        marginTop: '90vh',
                    },
                    duration: 1,
                });
                setEndOpen(true);
                return;
            }
        }
        setEndOpen(false); // 정상 입력시 닫기
    };

    // date picker open 제어
    const handleStartOpenChange = (open) => {
        // 유효성 실패 후 강제로 true로 유지할 수 있도록 분기 처리
        setStartOpen((prev) => {
            if (!open && moment(startDate).isAfter(endDate)) {
                return true; // 유효성 실패 상황이면 닫히지 않게 유지
            }
            if (!open && maxRangeDays && startDate && endDate) {
                const diffDays = moment(endDate).diff(
                    moment(startDate),
                    'days',
                );
                if (diffDays > maxRangeDays) {
                    return true; // 유효성 실패 상황이면 닫히지 않게 유지
                }
            }
            return open;
        });
    };

    const handleEndOpenChange = (open) => {
        setEndOpen((prev) => {
            if (!open && moment(endDate).isBefore(startDate)) {
                return true;
            }
            if (!open && maxRangeDays && startDate && endDate) {
                const diffDays = moment(endDate).diff(
                    moment(startDate),
                    'days',
                );
                if (diffDays > maxRangeDays) {
                    return true;
                }
            }
            return open;
        });
    };

    return {
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        startOpen,
        endOpen,
        handleStartChange,
        handleEndChange,
        handleStartOpenChange,
        handleEndOpenChange,
    };
};
